import toPairs from 'lodash/toPairs';
import differenceWith from 'lodash/differenceWith';

export const differingKeys = (obj1, obj2) => {
  if (!obj1 || !obj2) return [];
  const pairs1 = toPairs(obj1);
  const pairs2 = toPairs(obj2);
  return differenceWith(pairs1, pairs2, ([k1, v1], [k2, v2]) => k1 === k2 && v1 === v2).map(([k]) => k);
};
